module.exports = require("live/services/router");